import React, { useState } from "react";

import {
  FaUsers,
  FaCopy,
  FaShareAlt,
  FaGift,
  FaCheckCircle,
  FaUserPlus,
  FaMoneyBillWave,
  FaTrophy,
  FaInfoCircle,
  FaWhatsapp,
  FaFacebookF,
  FaEnvelope,
} from "react-icons/fa";

import "./ReferEarn.css";

function ReferEarn() {
  const [copied, setCopied] = useState(false);

  const referralCode = "ABNB-RAMESH-2405";

  const copyReferralCode = () => {
    navigator.clipboard.writeText(referralCode);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const shareReferral = async () => {
    const shareText = `Join APNB Seva Samithi using my referral code: ${referralCode}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "APNB Seva Samithi",
          text: shareText,
        });
      } catch (error) {
        console.log("Share cancelled");
      }
    } else {
      copyReferralCode();
    }
  };

  return (
    <div className="refer-page">

      {/* ==================================================
          PAGE HEADER
      ================================================== */}

      <div className="refer-page-header">
        <div>
          <h1>Refer &amp; Earn</h1>

          <div className="refer-breadcrumb">
            <span>Home</span>
            <span>›</span>
            <strong>Refer &amp; Earn</strong>
          </div>
        </div>
      </div>


      {/* ==================================================
          REFER YOUR FRIENDS
      ================================================== */}

      <section className="refer-main-card">

        <div className="refer-section-header">

          <div className="refer-section-icon blue">
            <FaUsers />
          </div>

          <div>
            <h2>Refer Your Friends</h2>

            <p>
              Invite your friends and family to join APNB Seva Samithi.
            </p>
          </div>

        </div>


        {/* ==================================================
            REFERRAL CODE
        ================================================== */}

        <div className="referral-code-section">

          <h3>Your Referral Code</h3>

          <div className="referral-code-row">

            <div className="referral-code">
              {referralCode}
            </div>

            <button
              type="button"
              className="copy-code-button"
              onClick={copyReferralCode}
            >
              <FaCopy />
              {copied ? "Copied!" : "Copy Code"}
            </button>

          </div>

          {copied && (
            <div className="copy-success-message">
              Referral code copied successfully.
            </div>
          )}

          <button
            type="button"
            className="share-referral-button"
            onClick={shareReferral}
          >
            <FaShareAlt />
            Share Referral
          </button>

        </div>

      </section>


      {/* ==================================================
          STATISTICS
      ================================================== */}

      <section className="referral-stats">

        <div className="referral-stat-card">

          <div className="referral-stat-icon blue">
            <FaUsers />
          </div>

          <div>
            <span>Total Referrals</span>
            <strong>8</strong>
          </div>

        </div>


        <div className="referral-stat-card">

          <div className="referral-stat-icon green">
            <FaCheckCircle />
          </div>

          <div>
            <span>Successful Referrals</span>
            <strong>5</strong>
          </div>

        </div>


        <div className="referral-stat-card">

          <div className="referral-stat-icon orange">
            <FaGift />
          </div>

          <div>
            <span>Rewards Earned</span>
            <strong>₹500</strong>
          </div>

        </div>


        <div className="referral-stat-card">

          <div className="referral-stat-icon purple">
            <FaTrophy />
          </div>

          <div>
            <span>Current Rank</span>
            <strong>#12</strong>
          </div>

        </div>

      </section>


      {/* ==================================================
          HOW IT WORKS
      ================================================== */}

      <section className="refer-card how-it-works-card">

        <div className="card-title-row">

          <div className="card-title-icon blue">
            <FaInfoCircle />
          </div>

          <div>
            <h2>How It Works</h2>

            <p>
              Refer your friends in four simple steps.
            </p>
          </div>

        </div>


        <div className="referral-steps">

          {/* STEP 1 */}

          <div className="referral-step">

            <div className="step-number">
              1
            </div>

            <div className="step-icon blue">
              <FaShareAlt />
            </div>

            <h3>
              Share Your Referral Link
            </h3>

            <p>
              Send your referral code or link to your friends and family members.
            </p>

          </div>


          {/* STEP 2 */}

          <div className="referral-step">

            <div className="step-number">
              2
            </div>

            <div className="step-icon purple">
              <FaUserPlus />
            </div>

            <h3>
              Friend Registers
            </h3>

            <p>
              Your friend creates an account using your referral code.
            </p>

          </div>


          {/* STEP 3 */}

          <div className="referral-step">

            <div className="step-number">
              3
            </div>

            <div className="step-icon green">
              <FaMoneyBillWave />
            </div>

            <h3>
              Friend Completes Membership
            </h3>

            <p>
              Your friend completes the membership payment successfully.
            </p>

          </div>


          {/* STEP 4 */}

          <div className="referral-step">

            <div className="step-number">
              4
            </div>

            <div className="step-icon orange">
              <FaGift />
            </div>

            <h3>
              You Receive Reward
            </h3>

            <p>
              Your eligible referral reward is credited to your account.
            </p>

          </div>

        </div>

      </section>


      {/* ==================================================
          SHARE WITH FRIENDS
      ================================================== */}

      <section className="refer-card share-friends-card">

        <div className="card-title-row">

          <div className="card-title-icon purple">
            <FaUsers />
          </div>

          <div>
            <h2>Share With Your Friends</h2>

            <p>
              Share your referral code through your preferred platform.
            </p>
          </div>

        </div>


        <div className="social-share-buttons">

          <button
            type="button"
            className="social-button whatsapp"
            onClick={() =>
              window.open(
                `https://wa.me/?text=Join APNB Seva Samithi using my referral code ${referralCode}`,
                "_blank"
              )
            }
          >
            <FaWhatsapp />
            WhatsApp
          </button>


          <button
            type="button"
            className="social-button facebook"
            onClick={() =>
              window.open(
                "https://www.facebook.com/",
                "_blank"
              )
            }
          >
            <FaFacebookF />
            Facebook
          </button>


          <button
            type="button"
            className="social-button email"
            onClick={() =>
              (window.location.href =
                `mailto:?subject=Join APNB Seva Samithi&body=Use my referral code ${referralCode}`)
            }
          >
            <FaEnvelope />
            Email
          </button>

        </div>

      </section>


      {/* ==================================================
          REWARD INFORMATION
      ================================================== */}

      <section className="reward-information-card">

        <div className="reward-information-icon">
          <FaInfoCircle />
        </div>

        <div>

          <h2>
            Referral Reward Information
          </h2>

          <p>
            Rewards are credited after the referred member completes
            the membership registration and successful payment.
          </p>

        </div>

      </section>


    </div>
  );
}

export default ReferEarn;